import React from 'react';
import classNames from 'classnames';
import * as S from './GraphHeader.styles';
import TextRenderer from '../../TextRenderer';
const GraphHeader = ({
  heading,
  subHeading,
  description,
  handleTab,
  tabIndex,
  monthGmv,
  hotelTravelCompletedAmount,
  internationalSpends,
  internationalSpendsCallout,
  graphTemplateData,
}) => {
  const {
    title,
    period,
    travleCompletedCurrentMonth,
    hotelCompletedTravelCurrentMonth,
    travleCompletedCurrentMonthAmount,
    hotelCompletedCurrentMonthAmount,
  } = graphTemplateData || {};

  return (
    <S.GrphView theme={'theme2'}>
      <S.GrphViewHdr>
        <TextRenderer data={title} />
        <p className="poppinsBold font11 latoBlack11">{period}</p>
      </S.GrphViewHdr>
      <S.GrphViewDesc>
        <S.GraphHeaderRow>
          <S.GrphViewCol>
            <p className="amtLabel">
              <span className="font20">{monthGmv}</span>
              <span className="font10">/ {travleCompletedCurrentMonthAmount}</span>
            </p>
            <p className="font11">{travleCompletedCurrentMonth}</p>
          </S.GrphViewCol>
          <S.GrphViewCol>
            <p className="amtLabel">
              <span className="font20">{hotelTravelCompletedAmount}</span>
              <span className="font10">/ {hotelCompletedCurrentMonthAmount}</span>
            </p>
            <p className="font11">{hotelCompletedTravelCurrentMonth}</p>
          </S.GrphViewCol>
        </S.GraphHeaderRow>
        <div>
          {internationalSpendsCallout?.data?.length ? (
            <S.GrphViewCol>
              <p className="amtLabel">
                <span className="font20">{internationalSpends}</span>
              </p>
              {internationalSpendsCallout?.data?.map((callout, index) => (
                <div className={classNames(callout?.style?.customClasses)} key={index}>
                  {callout?.order?.map((item, idx) => (
                    <span className={classNames(callout[item]?.style?.customClasses)} key={idx}>
                      {callout[item]?.primaryText}&nbsp;
                    </span>
                  ))}
                  <br />
                </div>
              ))}

              {/* <p className="highlighted">
            Spend INR 70L to unlock <b>5gm Gold</b>{' '}
  </p>  */}
            </S.GrphViewCol>
          ) : (
            <></>
          )}
        </div>
      </S.GrphViewDesc>
    </S.GrphView>
  );
};

export default GraphHeader;
